import React from 'react'
import { connect } from 'react-redux'

import * as actions from "../../actions/index";
import warningAlert from "./warning-alert.png";
import {
    message,
    Alert,
    Steps,
    Button,
    Tooltip,
    Spin,
    Row,
    Col,
    Card,
    Typography,
    Popover,
    Modal,
    Form,
    Input,
    Radio,
    Checkbox,
    Select,
    Icon,
    Switch,
    Table,
    Divider,
    Popconfirm
} from "antd";
import { bindActionCreators } from "redux";

const FormItem = Form.Item;
const Step = Steps.Step;
const InputGroup = Input.Group;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export const NeedToGetShippingAddress = (props) => {


  const handleShippingAddressInfo = (e) => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
            const getUpdatedAddress = (memberId) => ({
                addressLine1: values[`ScoutsAddressline1-${memberId}`] || undefined,
                addressLine2: values[`ScoutsAddressline2-${memberId}`] || undefined,
                addressLine3: values[`ScoutsAddressline3-${memberId}`] || undefined,
                city: values[`ScoutsCity-${memberId}`] || undefined,
                state: values[`ScoutsState-${memberId}`] || undefined,
                zipCode: values[`ScoutsZipcode-${memberId}`] || undefined,
                countryId: values[`ScoutsCountryId-${memberId}`] || undefined,
                needToGetShippingAddress: false
            });

            let updatedSelectedAlumni = [...props.SelectedAlumni];
            const updatedNeedToGetShippingAddress = props.needToGetShippingAddress.map(eachAlumni => {
                const memberId = eachAlumni.memberId.toString();
                let updatedAddress;

                updatedSelectedAlumni = updatedSelectedAlumni.map(alum => {
                    if (alum.memberId.toString() === memberId) {
                        updatedAddress = getUpdatedAddress(memberId);
                        return {
                            ...alum,
                            ...updatedAddress
                        };
                    }
                    return alum;
                });

                return {
                    ...eachAlumni,
                    ...updatedAddress
                };
            });

            props.setShippingAddressToStateHandler(updatedNeedToGetShippingAddress, updatedSelectedAlumni);

            props.closeModalHandler();
        }
    });
};




    const countries = () => {
      if (props.countries) {
          let countriesarray = props.countries.sort((a, b) => a.name - b.name);
          return countriesarray.map((k, index) => {
              return (
                  <option key={index} value={k.id}>
                      {k.name}
                  </option>
              );
          });
      }
  };

    const  stateInputEle = () => {
        return (
            <input
                maxLength={2}
                style={{ textTransform: "uppercase" }}
                autoComplete={"off"}
            />
        );
    };

    const statesID = () => {
        if (props.allstates) {
            let statesarray = props.allstates;
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>
                        {k.short}
                    </option>
                );
            });
        }
    };

    const changeScoutCountryId = (eachRecord, e) => {
        const alumnis = [...props.needToGetShippingAddress];
        const updatedAlumnis = alumnis.map(alumni => {
            if (alumni.memberId === eachRecord.memberId) {
                return { ...alumni, countryId: e };
            }
            return alumni;
        });
        props.setShippingAddressToStateHandler(updatedAlumnis);
    }

    const render_USAAddressForm = (eachRecord) => {

        const { getFieldDecorator } = props.form;
        
    
        return (
            <Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label={'Scout\'s First Name'}
                        >
                            {getFieldDecorator('ScoutsFirstName', {
                                initialValue: eachRecord.firstName,
                            })(
                                <Input disabled={Boolean(eachRecord.firstName)} placeholder={'Scout\'s First Name'} />
                            )}
                        </FormItem>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label={'Scout\'s Last Name'}
                        >
                            {getFieldDecorator('ScoutsLastName', {
                                initialValue: eachRecord.lastName,
                                rules: [{ required: true, message: 'Enter Scout\'s Last Name!' }],
                            })(
                                <Input disabled={Boolean(eachRecord.lastName)} placeholder={'Scout\'s Last Name'} />
                            )}
                        </FormItem>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label={'Scout\'s MemberID'}
                        >
                            {getFieldDecorator('memberId', {
                                initialValue: eachRecord.memberId ? eachRecord.memberId : '',
                                // rules: [{ required: true, message: 'Enter Member ID!' }],
                            })(
                                <Input className={eachRecord.memberId ? "input-disabled" : ''} disabled={eachRecord.memberId ? true : false} placeholder="Scout\'s Member ID" />
                            )}
                        </FormItem>
                    </Col>
                </Row>
    
            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    
              {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem hasFeedback
                  label={'Scout\'s Email'}
                >
                  {getFieldDecorator('ScoutsEmail', {
                    initialValue: eachRecord.email ? eachRecord.email : '',
                    rules: [{ required: true, type: "email", 
                    message: 'Enter a valid Scout\'s Email'}]
                  })(
                    <Input placeholder={'Scout\'s Email'} />
                  )}
                </FormItem>
              </Col> */}
    
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem
                  label={ 'Scout\'s Country' }
                >
                  {getFieldDecorator( "ScoutsCountryId-"+eachRecord.memberId, {
                    initialValue:  (eachRecord.countryId && !eachRecord.countryId.includes("**")) ? eachRecord.countryId : "616",
                    rules: [{ required: true, message:  'Enter Scout\'s Country' }],
                  })(
                    <Select
                      showAction={['focus', 'click']}
                      showSearch
                      style={{ width: '100%' }}
                      placeholder="Select a Country"
                      optionFilterProp="children"
                      onChange={(e) => changeScoutCountryId(eachRecord, e)}
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {countries()}
                    </Select>
                  )}
                </FormItem>
              </Col>
    
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem hasFeedback
                  label={'Scout\'s Address Line 1'}
                >
                  {getFieldDecorator("ScoutsAddressline1-"+eachRecord.memberId, {
                    rules: [{ required: true, message: 'Enter Scout\'s Address Line 1!'}],
                  })(
                    <Input placeholder={'Scout\'s Address Line 1'} />
                  )}
                </FormItem>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem hasFeedback
                  label={'Scout\'s Address Line 2'}
                >
                  {getFieldDecorator("ScoutsAddressline2-"+eachRecord.memberId, {
                    rules: [{ required: false, message: 'Enter Scout\'s Address Line 2!' }],
                  })(
                    <Input placeholder={ 'Scout\'s Address Line 2'} />
                  )}
                </FormItem>
              </Col>
            </Row>
    
            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    
              { /* Hiding Addressline 3 as per changes from AAG-1026
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Address Line 3"
                        >
                            {getFieldDecorator('addressline3', {
                                // initialValue: props.selectedRecord.address3 ? props.selectedRecord.address3 : "",
                                rules: [{ required: false, message: 'Enter Your Address!' }],
                            })(
                                <Input placeholder="Address Line 3"
                                // className={props.selectedRecord.address3 ? 'input-disabled' : ''}
                                // disabled={props.selectedRecord.address3 ? true : false} 
                                />
                            )}
                        </FormItem>
                            </Col> */}
    
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem hasFeedback
                  label={'Scout\'s City'}
                >
                  {getFieldDecorator('ScoutsCity-'+eachRecord.memberId, {
                    rules: [{ required: true, min: 2, message: 'Enter Scout\'s City' }],
                  })(
                    <Input placeholder={'Scout\'s City' } />
                  )}
                </FormItem>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem hasFeedback
                  label={'Scout\'s State'}
                >
                  {getFieldDecorator( 'ScoutsState-'+eachRecord.memberId, {
                    rules: [{ required: true, message: 'Enter Scout\'s State!' }],
                  })(
                    <Select
                      // disabled={props.selectedRecord.stateId ? true : false}
                      getInputElement={stateInputEle}
                      showAction={['focus', 'click']}
                      showSearch
                      style={{ width: '100%', textTransform: 'uppercase' }}
                      placeholder="Select a State"
                      optionFilterProp="children"
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {statesID()}
                    </Select>
                  )}
                </FormItem>
              </Col>
                    
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <FormItem hasFeedback
                  label={'Scout\'s Zip Code'}
                >
                  {getFieldDecorator('ScoutsZipcode-'+eachRecord.memberId, {
                    rules: [{ required: true, max: 5, message: 'Enter Scout\'s Zip Code!' }],
                  })(
                    <Input placeholder={'Scout\'s Zip Code'} maxLength={5} />
                  )}
                </FormItem>
              </Col>
    
            </Row>
    
            
            <Divider />
          </Row>
        );
      }
    
    const render_nonUSA_address = (eachRecord) => {
    
        const { getFieldDecorator } = props.form;

    
        return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
          <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem
                label={'Scout\'s First Name'}
              >
                {getFieldDecorator('ScoutsFirstName-'+eachRecord.memberId, {
                  initialValue: eachRecord.firstName,
                  rules: [{ required: true, message: 'Enter Scout\'s First Name' }],
                })(
                  <Input disabled={Boolean(eachRecord.firstName)} placeholder={'Scout\'s First Name'} />
                )}
              </FormItem>
            </Col>
    
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem
                label={'Scout\'s Last Name'}
              >
                {getFieldDecorator('ScoutsLastName-'+eachRecord.memberId, {
                  initialValue: eachRecord.lastName,
                  rules: [{ required: true, message: 'Enter Scout\'s Last Name'}],
                })(
                  <Input disabled={Boolean(eachRecord.lastName)} placeholder={'Scout\'s Last Name'} />
                )}
              </FormItem>
            </Col>
    
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label={'Scout\'s MemberID'}
                        >
                            {getFieldDecorator('memberId', {
                                initialValue: eachRecord.memberId ? eachRecord.memberId : '',
                                // rules: [{ required: true, message: 'Enter Member ID!' }],
                            })(
                                <Input className={eachRecord.memberId ? "input-disabled" : ''} disabled={eachRecord.memberId ? true : false} placeholder="Scout\'s Member ID" />
                            )}
                        </FormItem>
                    </Col>
              
    
          </Row>
    
          <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
          
    
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem
                label={'Scout\'s Country' }
              >
                {getFieldDecorator('ScoutsCountryId-'+eachRecord.memberId, {
                  initialValue: (eachRecord.countryId && !eachRecord.countryId.includes("**")) ? eachRecord.countryId : "616",
                  rules: [{ required: true, message: 'Enter Scout\'s Country!'}],
                })(
                  <Select
                    // className={props.scoutsCountry ? 'input-disabled' : ''}
                    // disabled={props.scoutsCountry ? true : false}
                    showAction={['focus', 'click']}
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Select a Country"
                    optionFilterProp="children"
                    onChange={(e) => {
                      changeScoutCountryId(eachRecord, e)
                    }}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {countries()}
                  </Select>
                )}
              </FormItem>
            </Col>
    
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem hasFeedback
                label={(
                  <span>
                    {'Scout\'s Address Line 1' }&nbsp;
                    <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
                      <Icon type="info-circle-o" />
                    </Tooltip>
                  </span>
                )}
              >
                {getFieldDecorator('ScoutsAddressline1-'+eachRecord.memberId, {
                  // initialValue: props.selectedRecord.address1 ? props.selectedRecord.address1 : "",
                  rules: [{ required: true, message: 'Enter Scout\'s Address Line 1' }],
                })(
                  <Input placeholder={'Scout\'s Address Line 1'}
                  // className={props.selectedRecord.address1 ? 'input-disabled' : ''}
                  // disabled={props.selectedRecord.address1 ? true : false}
                  />
                )}
              </FormItem>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem hasFeedback
                style={{ marginBottom: '0px' }}
                label={(
                  <span>
                    { 'Scout\'s Address Line 2'}&nbsp;
                    <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
                      <Icon type="info-circle-o" />
                    </Tooltip>
                  </span>
                )}
              //extra="City, Territory, Postal Code, Country"
              >
                {getFieldDecorator( 'ScoutsAddressline2-'+eachRecord.memberId, {
                  // initialValue: props.selectedRecord.address2 ? props.selectedRecord.address2 : "",
                  rules: [{ required: false, message:  'Enter Scout\'s Address Line 2' }],
                })(
                  <Input placeholder={ 'Scout\'s Address Line 2'}
                  // className={props.selectedRecord.address2 ? 'input-disabled' : ''}
                  // disabled={props.selectedRecord.address2 ? true : false} 
                  />
                )}
              </FormItem>
            </Col>
    
    
          </Row>
    
          <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
          
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem hasFeedback
                style={{ marginBottom: '0px' }}
                label={(
                  <span>
                    {'Scout\'s Address Line 3'}&nbsp;
                    <Tooltip placement="top" title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver, BC V5X 2H6">
                      <Icon type="info-circle-o" />
                    </Tooltip>
                  </span>
                )}
                extra="City, Territory, Postal Code, Country"
              >
                {getFieldDecorator('ScoutsAddressline3-'+eachRecord.memberId, {
                  // initialValue: props.selectedRecord.address3 ? props.selectedRecord.address3 : "",
                  rules: [{ required: true, message: 'Enter Scout\'s Address Line 3'}],
                })(
                  <Input placeholder="Address Line 3"
                  // className={props.selectedRecord.address3 ? 'input-disabled' : ''}
                  // disabled={props.selectedRecord.address3 ? true : false} 
                  />
                )}
              </FormItem>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem hasFeedback
                style={{ marginBottom: '0px' }}
                label={(
                  <span>
                    {'Scout\'s Address Line 3'}&nbsp;
                    <Tooltip placement="top" title="List the city, territory and country according to country standards (Southampton, SO53 5PD, UK; Vancouver">
                      <Icon type="info-circle-o" />
                    </Tooltip>
                  </span>
                )}
                extra="City, Territory, Country"
              >
                {getFieldDecorator('ScoutsAddressline3-'+eachRecord.memberId, {
                  // initialValue: props.selectedRecord.address3 ? props.selectedRecord.address3 : "",
                  rules: [{ required: true, message: 'Enter Scout\'s Address Line 3'}],
                })(
                  <Input placeholder="Address Line 3"
                  // className={props.selectedRecord.address3 ? 'input-disabled' : ''}
                  // disabled={props.selectedRecord.address3 ? true : false} 
                  />
                )}
              </FormItem>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <FormItem hasFeedback
                label={'Scout\'s Postal Code'}
              >
                {getFieldDecorator('ScoutsZipcode-'+eachRecord.memberId, {
                  rules: [{ required: true, max: 10, message: 'Enter Scout\'s Zip Code!'}],
                })(
                  <Input placeholder={'Scout\'s Zip Code'} maxLength={10} />
                )}
              </FormItem>
              </Col>
          </Row>
          <Divider />
        </Row>
        )
      }

  return (
    <Modal
    className="multiple-r-modal"
    title={false}
    footer={false}
    closable={false}
    visible={props.doesShowModalToGetIndividualsShippingAddress}
    centered
    onCancel={() => props.closeModalHandler()}
    style={{ width: '500px' }}
>

    <Row type="flex" align="left">
        <Col xs={24}>
            <div >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    <img src={warningAlert} width="25px" height="25px" style={{ marginRight: '10px' }} />
                    <span className="modal-header">Missing Information</span>
                </div>
                <div className="modal-desc" style={{ margin: '10px 0px' }}>
                It appears the required shipping address information is missing for the following individuals: Please provide that information in order to complete your
                    application process.
                </div>
            </div>
        </Col>
    </Row>
     
    <Row type="flex" align="center">
            <div className="step-container margin-top-20 record-found-select-btn">
            <Form onSubmit={handleShippingAddressInfo} className="IndividualsShippingAddress-form alumni-ui" style={{ width: '100%' }}>
                <Row>
                    <Col className="card-margin" span={24}>
                        {props.needToGetShippingAddress.map(eachAlumni => {
                            if ((!eachAlumni.countryId) || eachAlumni.countryId.includes("***") || eachAlumni.countryId.toString() == '616' || eachAlumni.countryId == '')
                                return  render_USAAddressForm(eachAlumni);
                                else return render_nonUSA_address(eachAlumni);
                        })}
                    </Col>
                </Row>

                <Row type='flex' style={{ justifyContent: 'end', alignItems: 'center' }}>
                    <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={5} xl={5}>
                        <div className='step-container margin-top-20' >
                            <Button type="primary" className='back-btn' style={{ fontSize: '13px', width: '100%' }} onClick={() => props.closeModalHandler()}>CANCEL</Button>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                        <div className='step-container margin-top-20' >
                            <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} htmlType='submit'>SUBMIT</Button>
                        </div>
                    </Col>
                </Row>

                </Form>
            </div>
    </Row>


</Modal>
  )
}

const mapStateToProps = state => {
    return {
        allstates: state.allstatesreducer.states,
        countries: state.countriesreducer.countries,
        phonecode: state.phonecountrycodereducer.code,
    }
}

const mapDispatchToProps = (dispatch) => {
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(NeedToGetShippingAddress))


// WEBPACK FOOTER //
// ./src/components/BulkUpload/NeedToGetShippingAddress.js